import cabri from "./cabri-app";
import browserInfo from "./browserInfo";
import * as BABYLON from "babylonjs/babylon.max";

const keyDownALT = 2, keyDownSHIFT = 4, keyDownCTRL = 8, keyDownMETA = 16;

class GestureHandler {

    constructor () {
        this.lastPointerSpeed = 0;
        this.timeLastEvent = new Date().getTime();

        this.isFocussed = true; // apparently difficult to track
        this.hasMouse = browserInfo.hasMouse;
        this.hasTouch = browserInfo.hasTouch;
        this.touchedGeomObject = null;
        this.shouldMoveVertically = false;
        this.keyDownALT =  keyDownALT;
        this.keyDownSHIFT = keyDownSHIFT;
        this.keyDownCTRL = keyDownCTRL;
        this.keyDownMETA = keyDownMETA;
    }





    registerListeners () {
        cabri.camera.attachControl(cabri.canvas, false, true, 1);
        // false: noPreventDefault <- false meaning canvas default actions are
        // not active
        let pointers = cabri.camera.inputs.attached["pointers"];
        if (pointers) {
            pointers.buttons = [2];
            pointers.multiTouchPanAndZoom = true;
        }

        cabri.scene.onKeyboardObservable.add(this.handleKey);
        cabri.scene.onPointerObservable.add(this.handlePointer);

        // todo: register touch listeners which cancel mouse-events
        //  and activates browserInfo.hasTouch

    }

    handleKey (kbInfo) {
        switch (kbInfo.type) {
            case BABYLON.KeyboardEventTypes.KEYDOWN:
                cabri.gestureHandler.keyMask =
                    (kbInfo.event.altKey ? keyDownALT : 0) |
                    (kbInfo.event.shiftKey ? keyDownSHIFT : 0) |
                    (kbInfo.event.ctrlKey ? keyDownCTRL : 0) |
                    (kbInfo.event.metaKey ? keyDownMETA : 0);
                break;
            case BABYLON.KeyboardEventTypes.KEYUP:
                cabri.gestureHandler.keyMask =
                    kbInfo.event.altKey ? keyDownALT :
                    0 | (kbInfo.event.shiftKey ? keyDownSHIFT : 0) |
                        (kbInfo.event.ctrlKey ? keyDownCTRL : 0) |
                        (kbInfo.event.metaKey ? keyDownMETA : 0);
                break;
        }

        let oldValue = cabri.gestureHandler.shouldMoveVertically;
        cabri.gestureHandler.shouldMoveVertically =
            (cabri.gestureHandler.keyMask & keyDownSHIFT) !== 0;
        if(oldValue !== cabri.gestureHandler.shouldMoveVertically) {
            let tool = cabri.toolbar.getCurrentTool();
            if(tool && tool.handleDirChange) {
                tool.handleDirChange(cabri.gestureHandler.shouldMoveVertically);
            }
        }
    }


    handlePointer (pointerInfo) {
        let tool = cabri.toolbar.getCurrentTool();
        const button = pointerInfo.event.button;
        if(tool && button !== 2) {
            tool.handlePointer(pointerInfo);
        }
    }

}

const gestureHandler = new GestureHandler();

export default gestureHandler;